import { Component, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { AppService } from './app.service';
import { Network } from '@ionic-native/network/ngx';
import { ErrorModalService } from './services/error-modal.service';
import { Storage } from '@ionic/storage';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    public appService: AppService,
    private network: Network,
    private errorModal: ErrorModalService,
    private storage: Storage
  ) {
  }

  async ngOnInit() {
    await this.storage.create();
    this.initializeApp();
    if (this.network.type === 'none') {
      // console.log('nonene');
      this.networkModal(true);
    }
    this.network.onDisconnect().subscribe(res => {
      // console.log('disconnected');
      this.networkModal(true);
    });
    this.network.onConnect().subscribe(res => {
      // console.log('connected');
      this.networkModal(false);
    });
  }

  networkModal(status) {
    if (status) {
      const title = 'No Internet Connection';
      const detail = 'Check Your Network Setting and Try Again';
      this.errorModal.showModal({ title, detail });
    } else {
      this.errorModal.hideModal();
    }
  }

  async initializeApp() {
    // this.platform.ready().then(async () => {
    this.statusBar.styleDefault();

    this.statusBar.backgroundColorByHexString('#060606');

    this.splashScreen.hide();
    await this.appService.initAppData();
    // this.appService.canShowSideMenu();
    // });
  }
}
